import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import {
  JOB_FUNCTIONS,
  JobFunction,
} from '#/utils/constants/general/jobFunctions';

export function jobKeywordsFacet(i18n: I18nFn) {
  return {
    id: 'jobKeywordsFacet',
    name: 'functions',
    get title() {
      return i18n('Job Function');
    },
    type: 'array',
    options: Object.keys(JobFunction),
    optionTitles: JOB_FUNCTIONS(i18n),
  } as const satisfies SearchFacetData;
}
